import { getIsDigitalSignEnabled } from '../api/digitalSign';
import { getConfiguration } from '../api/settings';
import authService from '../components/api-authorization/AuthorizeService';

const requestConfiguration = 'CONFIGURATION_REQUEST';
const receiveConfiguration = 'CONFIGURATION_RECEIVE';
const failConfiguration = 'CONFIGURATION_FAILURE';
const requestDigitalSign_Enabled = 'DIGITALSIGN_ENABLED_REQUEST';
const receivetDigitalSign_Enabled = 'DIGITALSIGN_ENABLED_RECEIVE';

const initialState = { isLoading: false, settings: {}, error: false };

const CONFIGURATION_MAX_ATTEMPTS = 3;
const CONFIGURATION_RETRY_DELAYS_MS = [2000, 4000];
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const settingsActions = {

    requestConfiguration: () => async (dispatch) => {
        dispatch({ type: requestConfiguration });

        for (let attempt = 1; attempt <= CONFIGURATION_MAX_ATTEMPTS; attempt++) {
            try {
                const response = await getConfiguration();
                dispatch({ type: receiveConfiguration, config: response.data });
                return;
            }
            catch (error) {
                console.log(error);
                if (attempt === CONFIGURATION_MAX_ATTEMPTS) {
                    dispatch({ type: failConfiguration });
                    return;
                }
                await wait(CONFIGURATION_RETRY_DELAYS_MS[attempt - 1]);
            }
        }
    },

    requestDigitalSignEnabled: () => async (dispatch) => {
        dispatch({ type: requestDigitalSign_Enabled });

        try {
            const user = await authService.getUser();
            const isEnabled = user?.signature_enabled?.toLowerCase() === "true";

            dispatch({ type: receivetDigitalSign_Enabled, isEnabled });
        }
        catch (error) {
            console.log(error);
            dispatch({ type: receivetDigitalSign_Enabled, isEnabled: false });
        }
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestConfiguration) {
        return {
            ...state,
            isLoading: true,
            error: false
        };
    }
    if (action.type === receiveConfiguration) {
        return {
            ...state,
            settings: action.config,
            isLoading: false,
            error: false
        };
    }
    if (action.type === failConfiguration) {
        return {
            ...state,
            isLoading: false,
            error: true
        };
    }
    if (action.type === requestDigitalSign_Enabled) {
        return {
            ...state,
            isLoading: true
        };
    }
    if (action.type === receivetDigitalSign_Enabled) {

        return {
            ...state,
            settings: { ...state.settings, digitalSignEnabled: action.isEnabled },
            isLoading: false
        };
    }

    return state;
};
